import { gql } from '@apollo/client';

export const GET_INDICATOR = gql`
  query GetIndicator($id: ID!) {
    indicator: getIndicator(id: $id) {
      id
      type
      unit
      measurementUnit
      numberOfDataEntries
      name
      startDate
      endDate
      target
      targetValue
      intervention {
        id
      }
      outcomeTheme {
        id
      }
      impactTheme {
        id
      }
      period {
        id
        name
      }
    }
  }
`;
